import React from 'react';

const WidgetArchives = () => {
    return (
        <div id="archives-2" className="widget widget_archive">
            <h6 className="widget-title">Archives</h6>

            <ul>
                <li>
                    <a title="January 2020" href={ process.env.PUBLIC_URL + '/news' }>January 2020</a>
                </li>
            </ul>
        </div>
    );
}

export default WidgetArchives;
